import { isPrivate } from '@/config/private';
import { loadResource } from '@tencent/qd-lib';
const { MODE } = require('src/config/env');

let taskArr = [];
const errLoadCount = {};

function loadComponent(name) {
  return new Promise((resolve, reject) => {
    if (name) {
      if (window[name]) {
        resolve(window[name].default);
      } else {
        let gtimgDomain = '';

        if (/^local/.test(window.location.host) || /^oa/.test(window.location.host)) {
          gtimgDomain = 'https://oa.gtimg.com';
        } else if (/.qidian.qq.com$/.test(window.location.host)) {
          gtimgDomain = 'https://bqq.gtimg.com';
        }

        const jsPath = `${gtimgDomain}/qidian-common/${name}.umd.min.js`;

        // const jsPath = `http://localhost:5000/${name}.umd.min.js`;

        loadResource(jsPath, () => {
          resolve(window[name].default);
        });
      }
    } else {
      reject(new Error('加载组件的name为空'));
    }
  });
}

export function initComponent(name) {
  const AsyncComponent = () => ({
    // 需要加载的组件 (应该是一个 `Promise` 对象)
    component: loadComponent(name),
    // 异步组件加载时使用的组件
    // loading: LoadingComponent,
    // 加载失败时使用的组件
    // error: ErrorComponent,
    // 展示加载时组件的延时时间。默认值是 200 (毫秒)
    // delay: 200,
    // 如果提供了超时时间且组件加载也超时了，
    // 则使用加载失败时使用的组件。默认值是：`Infinity`
    // timeout: 3000
  });

  return AsyncComponent;
}

function taskArrHandle() {
  taskArr.forEach((item) => {
    const { name, version, options, resolve } = item;
    setTimeout(() => {
      loadMarketComponent(name, version, options).then((res) => {
        resolve(res);
      });
    }, 0);
  });

  taskArr = [];
}

function loadMarketComponent(name, version = '0.0.1', options) {
  return window._rhinoComponents.marketRequire(name, version, options).then((res) => {
    if (res && res.default) {
      return res.default;
    }
    return res;
  })
    .catch((e) => {
      if (errLoadCount[name]) {
        errLoadCount[name]++;
      } else {
        errLoadCount[name] = 1;
      }

      // 加载失败重试一次
      if (errLoadCount[name] <= 1) {
        return loadMarketComponent(name, version, options);
      }

      console.log(`[loadMarketComponent] ${name} ${version} ${options} error`, e);
      return {};
    });
}


function marketRequire(name, version, options) {
  return new Promise((resolve) => {
    if (window._rhinoComponents && window._rhinoComponents.marketRequire) {
      loadMarketComponent(name, version, options).then((res) => {
        resolve(res);
      });
    } else {
      let marketPath = 'https://bqq.gtimg.com/vhtml_market';

      if (MODE === 'gray') {
          marketPath = 'https://bqq.gtimg.com/vhtml_market_gray';
      }

      if (/^local/.test(window.location.host) || /^oa/.test(window.location.host)) {
        marketPath = 'https://oaimg.b.qq.com/vhtml_market';
      }


      if (isPrivate) {
        marketPath = '/static/vhtml_market';
      }

      taskArr.push({ name, version, options, resolve });

      return loadResource(`${marketPath}/static/market-require_0.0.2/index.js`, () => {
        // loadMarketComponent(name, version).then(res => {
        //     resolve(res);
        // });

        taskArrHandle();
      });
    }
  });
}

export function marketAsyncComponent(name, version, options) {
  const AsyncComponent = () => ({
    component: marketRequire(name, version, options),
  });

  return AsyncComponent;
}


